"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradeMaterial = void 0;
var GradeMaterial = /** @class */ (function () {
    function GradeMaterial(_a) {
        var _b = _a._id, _id = _b === void 0 ? { m: '', g: '' } : _b, _c = _a.GRADE, GRADE = _c === void 0 ? '' : _c, _d = _a.DIMENSAO_1, DIMENSAO_1 = _d === void 0 ? '' : _d, _e = _a.DIMENSAO_2, DIMENSAO_2 = _e === void 0 ? '' : _e, _f = _a.MULTIPLO, MULTIPLO = _f === void 0 ? '' : _f, _g = _a.GRUPO_UME, GRUPO_UME = _g === void 0 ? '' : _g, _h = _a.FATOR_RISCO, FATOR_RISCO = _h === void 0 ? '' : _h, _j = _a.REGRA_ESTOQUE, REGRA_ESTOQUE = _j === void 0 ? '' : _j, _k = _a.VERSAO_SEAMLESS, VERSAO_SEAMLESS = _k === void 0 ? '' : _k;
        this._id = _id;
        this.GRADE = GRADE;
        this.DIMENSAO_1 = DIMENSAO_1;
        this.DIMENSAO_2 = DIMENSAO_2;
        this.MULTIPLO = MULTIPLO;
        this.GRUPO_UME = GRUPO_UME;
        this.FATOR_RISCO = FATOR_RISCO;
        this.REGRA_ESTOQUE = REGRA_ESTOQUE;
        this.VERSAO_SEAMLESS = VERSAO_SEAMLESS;
    }
    return GradeMaterial;
}());
exports.GradeMaterial = GradeMaterial;
//# sourceMappingURL=GradeMaterial.js.map